@if (availabilityView) {
  @switch (availabilityView.status) {
    @case ('UNAVAILABLE') {
      <x-shop-pill
        [matTooltip]="availabilityView.unavailableReason?.description ?? ''"
        matTooltipPosition="below"
        matTooltipClass="accent p-4"
      >
        {{ availabilityView.unavailableReason?.label }}
      </x-shop-pill>
    }
    @case ('UNLISTED') {
      <ng-container *ngTemplateOutlet="LIMITED"></ng-container>
    }
    @case ('LIMITED') {
      <ng-container *ngTemplateOutlet="LIMITED"></ng-container>
    }
    @case ('OUT_OF_STOCK') {
      <x-shop-pill
        *ngIf="availableQuantity; else OOS"
        [matTooltip]="availabilityView.unavailableReason?.description ?? ''"
        matTooltipPosition="below"
        matTooltipClass="accent p-4"
        color="error"
      >
        Only {{ availableQuantity }} available
      </x-shop-pill>

      <ng-template #OOS>
        <x-shop-pill
          class="out-of-stock"
          [matTooltip]="availabilityView.unavailableReason?.description ?? ''"
          matTooltipPosition="below"
          matTooltipClass="accent p-4"
          color="disabled"
        >
          {{ availabilityView.unavailableReason?.label }}
        </x-shop-pill>
      </ng-template>
    }
    @case ('AVAILABLE') {
      <x-shop-pill
        *ngIf="availabilityView.availableState as nextAvailableState"
        [color]="nextAvailableState.status | availabilityColor"
      >
        {{ nextAvailableState?.description }}
      </x-shop-pill>
    }
  }
}

<ng-template #LIMITED>
  @if (shopConfig.features.availability.showDeliveryRegionBadges) {
    @for (region of availableRegions; track region.id) {
      <x-shop-pill
        [matTooltip]="'This item is exclusively available for delivery in ' + region.name + '.'"
        matTooltipPosition="below"
        matTooltipClass="accent p-4"
      >
        {{ region.label }}
      </x-shop-pill>
    }
  }
</ng-template>
